<template>
    <letter-layout
        title="感恩命运，让我遇见了你"
        date="2026年3月15日"
        sign-date="2026年3月10日"
        :paragraphs="paragraphs"
    />
</template>

<script>
import LetterLayout from './letterLayout.vue';

export default {
    components: { LetterLayout },
    data() {
        return {
            paragraphs: [
                '感恩命运，让我遇见了你。 第一次见你，听你的声音，我就知道是你了。不是那种轰轰烈烈的确认，而是心里某个地方，轻轻地，被敲了一下。',
                '真正和你相处的时间很短。短到还没反应过来，你就已经住进来了。开始留意你说话时的眼神，记住你笑的样子，甚至习惯了你在身边的那种古灵精怪。最后发现原来一个人住进来，是不需要很长时间的。',
                '没有在一起的时候，经常想你。想你有没有睡好，今天穿了什么衣服，早饭吃了什么。想你有没有不开心的事，我能不能帮你分担一点，想你有没有被垃圾欺负，想你有没有受委屈。',
                '想得多了，有时间又觉得自己挺可悲的，又能怎样呢。所以有时候更多是心痛，痛我们相逢的时候，你已经是别人的了。 于是，所有的“想”，大概就只能停在这里，永远停在这里。',
                '年前你就说，你们要一起去旅游。你说的时候，我笑着听，心里却像被什么东西轻轻揪了一下。我也说希望放假回去了，你一定要记住有个人在一直惦记你，希望你能想着随时能跟我分享，想知道你的一起，想知道你好不好。',
                '可回去之后幷没有，甚至一天没有纠缠你，你居然狠心的把QQ卸载了，然后接下来的几天你就失联了，再也看不到你的信息，然后我整晚的睡不好，半夜醒来都想着看你的信息，手机拿在手上无时无刻的想看你回信息了吗，然而并没有。 觉得你是不想再被打扰了吧，然后我该醒了吧，即使再有不舍，再心痛又怎样呢。',
                '你回来的那天，我甚至都不知道。直到我下班回来看到你家灯亮着才知道。那一刻心里五味杂陈，心里痛是真的，开心能看到你也是真的。看到你一个人忙忙碌碌忙碌的样子，心里真的非常心疼，又不忍心放下你。',
                '站在阳台，看着你家方向想了一晚上，大概以后想起来就会心痛吧。',
                '时间真快，从遇到你到今天，已经快5个月了。我知道你也感觉到了，我太想你了，想得你有点怕。但是你却一直在跟我保持距离，把我往外推，让我也感受不到你的在乎。大概以后不会把你抓太紧，所以你也不用那么害怕不用内耗了。',
                '我想说的是，我永远不会忘记你，也不会刻意去忘。',
                '想你的时候，我就看看你照片，想看看你空间，甚至想看你是不是在打游戏，想想那些很短、很短在一起的日子，很美很知足。所以即使以后你不想我再纠缠你的时候，不要突然失联，也不想成为你的陌路人，就做个普通的朋友吧，一个在你身后默默守护你的朋友吧，一个只为听你说的朋友，大概我存在的意义也仅如此了。',
                '如果你快乐，我就远远看着；如果你苦，就倒给我。请别删我，别拉黑我。让我的QQ和微信留在你的列表里，不管你在哪，我去了哪，只要上线，我就能看见你。',
                '头像亮着也好，灰着也好，我都知道你还在那里。如果你需要我，不管你在哪，不管我在哪，我都会去找你。这句话，我说到做到。',
                '好吧，就到这里吧。心痛无比，希望你好好的，希望你一直在，希望你余生幸福。 有些人来过，就永远不会走。不是在你身边，是在你心里。'
            ]
        };
    }
};
</script>
